<template>
   <div class="content" @click='reverse()'>
    <h1>甘肃信息惠民服务热线接线分类</h1>
    <h2>{{time}}</h2>
    <div class="charts" id="main"></div>
  </div>
</template>

<script>
export default {
  name: 'serviceCharts2',
  data () {
    return {
		option: {
			title: {
			  // text: '2018年9月20日当日接线统计',
			  // subtext: '总计668件'
			},
			tooltip: {
			  trigger: 'axis',
			  axisPointer: {
				type: 'cross',
				label: {
				  backgroundColor: '#283b56'
				}
			  }
			},

			legend: {
			  data: ['当日', '总计']
			},
			/* toolbox: {
			  show: true,
			  feature: {
				dataView: {readOnly: false},
				restore: {},
				saveAsImage: {}
			  }
			}, */
			dataZoom: {
			  show: false,
			  start: 0,
			  end: 200
			},
			xAxis: [
			  {
				type: 'category',
				boundaryGap: true,
				axisLabel: {
					fontWeight: 'bold',
					fontSize: 16
				},
				data: ['甘肃一卡通', '线上支付', '家庭服务', '物业服务', '便民终端', '意见建议', '配送服务', '电子商务', '再生资源回收', '其他']
			  }
			],
			yAxis: [
			  {
				type: 'value',
				scale: true,
				name: '接线量',
				//max: 100,
				min: 0,
				//interval: 10,
				boundaryGap: [0.2, 0.2]
			  }
			],
			series: [
			  {
				type: 'bar',
				name: '接线数',
				itemStyle: {
				  normal: {
					color: function (params) {
					  // 首先定义一个数组
					  var colorList = [
						'#F47A25', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3',
						'#B74AE5', '#0AAF9F', '#E89589', '#60C0EB', '#5472EC', '#F37126', '#FDB01F', '#4498FA', '#8B55FD', '#B72DFF', '#0BE0A6', '#7BCE4C'
					  ]
					  return colorList[params.dataIndex]
					},
					// 以下为是否显示
					label: {
					  show: true,
					  position: 'top'
					}
				  }
				},

				data: [{
					name: '甘肃一卡通',
					value: 15,
					items: ['业务网点查询', '卡内余额查询', '消费明细查询', '卡片挂失解挂', '公交问题投诉']
				}, {
					name: '线上支付',
					value: 7,
					items: ['虚拟卡申领解绑', '各类充值缴费', '扫码支付问题', '钱包充值问题']
				},{
					name: '家庭服务',
					value: 1,
					items: ['育婴嫂', '公安开锁', '整体保洁', '陪同病患', '吸油烟机', '新居开荒', '陇原妹保姆', '月嫂服务', '厨嫂', '擦玻璃']
				},{
					name: '物业服务',
					value: 6,
					items: ['物业缴费', '设备维修', '物品搬出', '生活缴费']
				},{
					name: '便民终端',
					value: 4,
					items: ['移机拆机', '终端吞卡', '终端布放', '各类充值缴费']
				},{
					name: '意见建议',
					value: 1,
					items: ['建议', '意见']
				},{
					name: '配送服务',
					value: 7,
					items: ['产品质量', '配送时间', '投诉建议']
				},{
					name: '电子商务',
					value: 11,
					items: ['产品质量', '配送时间', '投诉建议']
				}, {
					name: '再生资源回收',
					value: 6,
					items: ['废旧电子产品', '塑料', '报废车辆', '纸类', '黑有色金属', '橡胶', '有色金属', '木头']
				}, {
					name: '其他',
					value: 2,
					items: []
				}]
			  }
			]
		},
		count:10,
		level: false,
		xAxisData: ['甘肃一卡通', '线上支付', '家庭服务', '物业服务', '便民终端', '意见建议', '配送服务', '电子商务', '再生资源回收', '其他'],
		seriesData: []
	}
  },
  methods: {
    drawLine () {
      let vm = this
      let myChart = vm.$echarts.init(document.getElementById('main'))
	  myChart.setOption(vm.option)
	  myChart.on('click', function(params) {
		if (!vm.level) {
			if (!params.data.items.length) return;
			vm.clickToDetail(params);
			myChart.setOption(vm.option)
		} else {
			vm.resverse();
			myChart.setOption(vm.option)
		}
		vm.level = !vm.level;
	  })
	  let k = 0;
      setInterval(function () {
        var data0 = vm.option.series[0].data
		let len = data0.length;
		for (let i = 0; i < len; i++) {
			var n = data0[i].value
			console.log(k);
			if (i === k) {
				if (k === 5 || k === 8) {
					data0[i].value = n;
				} else {
					data0[i].value = n + 1//((Math.random() * 1).toFixed(0) - 0)
				}
			} else {
				data0[i].value = n
			}
		}
		if (k === 8) {
			k = 0;
		} else {
			k++;
		}
        myChart.setOption(vm.option)
      }, 5000)
    },
	clickToDetail (params) {
		let vm = this
		vm.seriesData = [...vm.option.series[0].data]
		vm.option.xAxis[0].data = params.data.items;
		let num = params.value;
		let arr = vm.splitNum(num, params.data.items.length);
		vm.option.series[0].data = arr;
	},
	resverse () {
		let vm = this
		console.table(this.seriesData)
		vm.option.xAxis[0].data = vm.xAxisData;
		vm.option.series[0].data = [...vm.seriesData];
		vm.seriesData = [];
	},
	splitNum (num, n) {
		//num:被分的数字，n:分的个数
		var arr = [];
		function _split(no) {
			var _i = no / 2;
			var _k = (_i * Math.random()).toFixed(0) - 0;
			return _k;
		}
		var _num = num;
		for (var i = 0; i < (n - 1); i++) {
			var _n = _split(_num);
			arr.push(_n);
			_num -= _n;
		}
		arr.push(_num);
		return arr;
	}
  },
  mounted () {
    let vm = this
    vm.drawLine()
  },
  computed: {
    time: function () {
      var myDate = new Date()
      let month = Number(myDate.getMonth()) + 1
      return myDate.getFullYear() + '年' + month + '月' + myDate.getDate() + '日'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
 html,body,.content,.charts {
   width: 100%;
   height: 100%;
 }
 .charts {
   padding-top: 300px;
    height: 900px;
 }
 h1 {
   width: 100%;
   color: #0034E4;
   text-align: center;
   font-size: 40px;
   position: absolute;
   top: 0;
   left: 0;
   line-height: 100px;
   margin-top: 80px;
 }
  h2 {
   width: 100%;
   color: #0034E4;
   text-align: center;
   font-size: 40px;
   position: absolute;
   top: 100px;
   left: 0;
   line-height: 100px;
   margin-top: 50px;
 }
</style>
